import { useEffect, type EffectCallback } from 'react';
import { useLatest } from './useLatest';

/**
 * Set something up outside React when the component mounts and tear it down when it unmounts
 * (start a session check, register with an external system). Runs once per mount, never on re-render.
 *
 * The escape hatch for mount-time work that is not an event, timer or subscription. It is not a place to
 * copy props into state, load data that depends on props, or react to a user action.
 */
export function useMountEffect(effect: EffectCallback): void {
    const latest = useLatest(effect);
    // Mount and unmount only, by definition.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => latest.current(), []);
}
